// extracted by mini-css-extract-plugin
export default {"virtual-container":"GRTable_virtual-container__TNFVk","table":"GRTable_table__MUTYG"};